export default __webpack_public_path__ + "static/media/exploded-view_thumbnail.be49e644.png";